const CARE_OF_PREFIX = /^c\/o\s*/i;

export const normalizeCareOf = (value: unknown): string | undefined => {
  if (typeof value !== 'string') return undefined;
  const name = value.trim().replace(CARE_OF_PREFIX, '').trim();
  return name || undefined;
};
